<template>
  <div class="card card-user">
    <div class="image">
      <img src="/static/img/background/background-3.jpg" alt="..." />
    </div>
    <div class="card-body">
      <div class="author">
        <a href="#">
          <img
            class="avatar border-gray"
            src="/static/img/central-gym150x150.webp"
            alt="..."
          />
          <h5 class="title">{{ user.name }}</h5>
        </a>
        <p class="description">@{{ user.userName }}</p>
      </div>
      <button class="btn btn-info w-100 mx-auto" @click="$emit('changePassword')">Cambiar contraseña</button>
      <!-- <p class="description text-center">
        "I like the way you work it
        <br />
        No diggity <br />
        I wanna bag it up"
      </p> -->
    </div>
    <div class="card-footer">
      <hr />
      <div class="button-container">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-6 ml-auto">
            <h5>
              12
              <br />
              <small>Socios</small>
            </h5>
          </div>
          <div class="col-lg-4 col-md-6 col-6 ml-auto mr-auto">
            <h5>
              2GB
              <br />
              <small>Membresias</small>
            </h5>
          </div>
          <div class="col-lg-3 mr-auto">
            <h5>
              {{ user.branches }}
              <br />
              <small>Sedes</small>
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      user: {
        name: "",
        userName: "",
        branches: 0,
      },
    };
  },
  beforeMount() {
    const userData = this.$store.getters.getUserData;
    this.user.name = userData.nombreUsuario;
    this.user.userName = userData.usuarioSesion;
    this.user.branches = JSON.parse(sessionStorage.getItem("xxxwypt5ip")).length
  },
};
</script>
<style></style>
